<template>
  <div class="specialty">
    <div class="main">
      <div class="screen-type-area">
        <div class="screen-type-row">
          分社:
          <span class="screen-type-item" :class="{on: dataParams.societyCode === '' || screenHover.societyCode === ''}" @click="dataParams.societyCode = ''">全部</span>
          <span
            v-for="(item, index) in screenTheme"
            :key="index"
            class="screen-type-item"
            :class="{on: dataParams.societyCode === index || screenHover.societyCode === index}"
            @mouseenter="screenHover.societyCode = index"
            @mouseleave="screenHover.societyCode = 'xxx'"
            @click="dataParams.societyCode = index"
          >
            {{ item }}
          </span>
        </div>
        <div class="screen-type-row">
          形式:
          <span class="screen-type-item" :class="{on: dataParams.form === '' || screenHover.form === ''}" @click="dataParams.form = ''">全部</span>
          <span
            v-for="(value, key) in screenForm"
            :key="key"
            class="screen-type-item"
            :class="{on: dataParams.form === key || screenHover.form === key}"
            @mouseenter="screenHover.form = key"
            @mouseleave="screenHover.form = 'xxx'"
            @click="dataParams.form = key"
          >
            {{ value }}
          </span>
        </div>
<!--        <div class="screen-type-row">-->
<!--          类型:-->
<!--          <span class="screen-type-item" :class="{on: dataParams.type === '' || screenHover.type === ''}" @click="dataParams.type = ''">全部</span>-->
<!--          <span-->
<!--            v-for="(value, key) in screenType"-->
<!--            :key="key"-->
<!--            class="screen-type-item"-->
<!--            :class="{on: dataParams.type === key || screenHover.type === key}"-->
<!--            @mouseenter="screenHover.type = key"-->
<!--            @mouseleave="screenHover.type = 'xxx'"-->
<!--            @click="dataParams.type = key"-->
<!--          >-->
<!--            {{ value }}-->
<!--          </span>-->
<!--        </div>-->
      </div>
      <div class="screen-result">
        <div v-for="(item,index) in screenList" :key="index" class="content-item" :class="{marginLeft30: index%2 === 1}">
          <div v-if="item.process" class="enroll" :style="{backgroundColor: $processMapping[item.process].color}">{{ $processMapping[item.process].name }}</div>
          <img v-if="item.img" :src="$urlPrefix + item.img" alt="">
          <div v-else class="coverArea">
            <p>{{ item.title }}</p>
          </div>
          <div class="details">
            <div v-if="societyCodeMapping[item.societyCode]" :style="{backgroundColor: societyCodeMapping[item.societyCode].color}">
              {{ societyCodeMapping[item.societyCode].name }}
            </div>
            <div :style="{backgroundColor: $typeColorMapping[item.activityType]}">
              {{ $typeMapping[item.activityType] }}
            </div>
            <span class="title" @click="checkDetails(item.pkid, item.type)">{{ item.title }}</span>
            <br>
            <p v-if="item.type === 'activity'">活动时间：{{ item.startTime }}</p>
            <p v-else>主讲人：{{ item.keynoteSpeaker}} </p>
            <span class="price-span">
              <template v-if="item.originPrice">
                <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                  <span class="old-price">￥{{ item.originPrice }}元/人</span>
                  <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                </template>
                <span v-else>￥{{ item.originPrice }}元/人</span>
              </template>
              <span v-else>免费</span>
            </span>
            <div class="check-details" @click="checkDetails(item.pkid, item.type)">查看详情</div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        align="left"
        style="margin: 30px 30px"
        layout="total, prev, pager, next, jumper"
        :current-page="pageNumber"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="5"
        :total="totalCount"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>

</template>

<script>
export default {
  name: 'Specialty',
  data() {
    return {
      societyCodeMapping: {
        'product-moudle': {
          name: '产品研习堂',
          color: '#EA5504'
        },
        'capital-moudle': {
          name: '资本对接营',
          color: '#3A65D3'
        },
        'operation-moudle': {
          name: '运维能力课',
          color: '#05B6B0'
        }
      },
      typeList: ['E00006', 'E00001', 'E00002', 'E00003', 'E00005'],
      pageNumber: 1,
      totalCount: 0,
      screenList: [],
      screenTheme: {
        'product-moudle': '产品研习堂',
        'operation-moudle': '运维能力课',
        'capital-moudle': '资本对接营'
      },
      screenForm: {
        D00001: '线上',
        D00002: '线下',
        D00003: '线上+线下'
      },
      screenType: {
        E00006: '在盈端',
        E00001: '培训盈',
        E00002: '盈享会',
        E00003: '微路演',
        E00005: '盈峰论'
      },
      dataParams: {
        societyCode: '',
        form: '',
        type: '',
        pageSize: 5
      },
      screenHover: {
        societyCode: '',
        form: '',
        type: ''
      }
    }
  },
  created() {
    if (this.$route.query.type) {
      this.dataParams.type = this.typeList[this.$route.query.type - 1]
      this.screenHover.type = this.typeList[this.$route.query.type - 1]
    }
  },
  watch: {
    dataParams: {
      handler(val) {
        this.handleCurrentChange(1)
      },
      deep: true
    }
  },
  methods: {
    checkDetails(pkid, type) {
      let toPath
      type === 'activity' ? toPath = '/activityDetail' : toPath = '/courseMain'
      this.$router.push({
        path: toPath,
        query: {
          pkid: pkid,
          pathList: JSON.stringify([
            {
              name: '专业活动',
              path: this.$route.fullPath
            }
          ])
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getData()
    },
    getData() {
      const param = JSON.parse(JSON.stringify(this.dataParams))
      param.pageNumber = this.pageNumber
      this.$post('/front/index/selectSociety', param).then(res => {
        if (res) {
          if (res.records.length > 0 && res.records[0].type === 'activity') {
            this.$emit('getActivityProcess', res.records)
          }
          this.screenList = res.records
          this.totalCount = res.total
        } else {
          this.screenList = []
          this.totalCount = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.specialty {
  width: 100%;
  background-color: #F6F6F5;
  text-align: center;
  padding: 50px 0;
  .main {
    width: 1200px;
    margin: 0 auto;
    .screen-type-area {
      width: 100%;
      .screen-type-row {
        width: 100%;
        height: 30px;
        margin-bottom: 30px;
        text-align: left;
        font-size: 22px;
        font-weight: 400;
        color: #333333;
        .screen-type-item {
          font-size: 18px;
          padding: 3px 10px;
          margin-right: 10px;
          cursor: pointer;
          border-radius: 3px;
        }
        .screen-type-item.on {
          background-color: #EA5504;
          color: #FFFFFF;
        }
      }
    }
    .screen-result {
      .content-item {
        width: 1200px;
        margin-top: 0;
        margin-bottom: 30px;
        .details {
          width: 900px;
          padding-right: 20px;
          .check-details {
            top: 55px;
          }
        }
        .enroll {
          top: -45px;
          right: -45px;
          width: 90px;
          height: 90px;
          font-size: 15px;
          line-height: 150px;
        }
      }
    }
    .content-item {
      position: relative;
      display: inline-block;
      width: 585px;
      height: 180px;
      margin-top: 30px;
      background: #FFFFFF;
      border-radius: 5px;
      padding: 15px 20px;
      box-sizing: border-box;
      overflow: hidden;
      .enroll {
        position: absolute;
        top: -31px;
        right: -31px;
        width: 63px;
        height: 63px;
        background-color: #0AC18F;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 109px;
        transform: rotate(45deg);
        z-index: 10;
      }
      img {
        display: inline-block;
        width: 210px;
        height: 150px;
        border-radius: 5px;
      }
      .details {
        display: inline-block;
        position: relative;
        width: 305px;
        height: 150px;
        margin-left: 30px;
        vertical-align: top;
        text-align: left;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        font-size: 14px;
        div {
          display: inline-block;
          width: 80px;
          height: 24px;
          background: #F69F60;
          margin-right: 10px;
          border-radius: 5px;
          text-align: center;
          color: #FFFFFF;
        }
        .title {
          font-size: 16px;
          cursor: pointer;
        }
        .title:hover {
          color: #EA5504;
        }
        p {
          width: 100%;
          padding-top: 15px;
          color: #999999;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .price-span {
          position: absolute;
          left: 0;
          bottom: -5px;
          .old-price {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            text-decoration: line-through;
            margin-right: 5px
          }
          span {
            color: #EF2727;
            font-size: 16px;
            font-weight: bold
          }
        }
        .check-details {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 108px;
          height: 30px;
          line-height: 30px;
          background: #EA5504;
          border-radius: 2px;
          text-align: center;
          cursor: pointer;
        }
        .check-details:hover {
          opacity: 0.9;
        }
      }
    }
    .content-item:hover {
      box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
    }
  }
}
</style>
